const userProfiles = {
  en: {
    details: "Details",
    request: "Request",
    newProfile: "New Profile",
    copyProfile: "Copy Profile",
    profileName: "Profile Name",
    insertProfileName: "Insert Profile Name",
    tagColor: "Tag Color",
    insertTagColor: "Insert Tag Color",
    description: "Description",
    insertDescription: "Describe the role of the profile you're requesting",
    users: "User(s)",
    usersUsing: " are using this profile",
    permissions: "Permissions",
    explainRequest: "Explain the request",
    insertExplainRequest:
      "Describe why this profile request is relevant to your team structure to help us in the approval",
    waitingAproval: "Waiting Approval",
    requestCreated: "Your request has been sent",
    describeConfirmedRequest: "Wait for the analysis for approval.",
    cancelRequest: "Cancel Request",
    requestNewProfileButton: "Request New Profile",
    viewProfile: "View Profile",
    userAmount: "user | users",
    userAmountText: "tied to this profile",
    titleCancelRequest: "Do you really want to cancel that request?",
    textCancelRequest: "Please confirm order",
    confirmedCancelRequest: "Cancel it",
    requestNewProfileCardText: "Click to request a new profile",
    requestCreatedAt: "Request created",
    reject: "Reject",
    approve: "Approve",
    approvalConfirmation: "Are you sure you want to approve this profile?",
    rejectionConfirmation: "Are you sure you want to reject this profile?",
    denialReason: "Please explain why the request was rejected",
    denialExplanation: "Explain cleary why the customer request was rejected."
  },
  pt: {
    details: "Detalhes",
    request: "Solicitar",
    newProfile: "Novo Perfil",
    copyProfile: "Copiar Perfil",
    profileName: "Nome do Perfil",
    insertProfileName: "Digite o Nome do Perfil",
    tagColor: "Cor da Tag",
    insertTagColor: "Insira Cor da Tag",
    description: "Descrição",
    insertDescription: "Descreva o papel do perfil que você está solicitando",
    users: "Usuário(s)",
    usersUsing: " usando este perfil",
    permissions: "Permissões",
    explainRequest: "Explique a solicitação",
    insertExplainRequest:
      "Descreva por que este perfil é relevante para a estrutura de sua equipe para nos ajudar na aprovação",
    waitingAproval: "Aguardando aprovação",
    requestCreated: "Sua solicitação foi enviada",
    describeConfirmedRequest: "Aguarde a análise para aprovação.",
    cancelRequest: "Cancelar solicitação",
    requestNewProfileButton: "Solicitar Novo Perfil",
    viewProfile: "Visualizar Perfil",
    userAmount: "usuario| usuarios",
    userAmountText: "relacionados a esse perfil",
    titleCancelRequest: "Você realmente deseja cancelar essa solicitação?",
    textCancelRequest: "Por favor, confirme o cancelamento",
    confirmedCancelRequest: "Cancelar agora",
    requestNewProfileCardText: "Clique para solicitar um novo perfil",
    requestCreatedAt: "Solicitação criada",
    reject: "Rejeitar",
    approve: "Aprovar",
    approvalConfirmation: "Are you sure you want to approve this profile?",
    rejectionConfirmation: "Are you sure you want to reject this profile?",
    denialReason: "Please explain why the request was rejected",
    denialExplanation: "Explain cleary why the customer request was rejected."
  },
  es: {
    details: "Detalles",
    request: "Solicitar",
    newProfile: "Nuevo Perfil",
    copyProfile: "Copiar Perfil",
    profileName: "Nombre del perfil",
    insertProfileName: "Insertar Nombre del perfil",
    tagColor: "Color de la etiqueta",
    insertTagColor: "Insert Color de la etiqueta",
    description: "Descripción",
    insertDescription: "Describa la función del perfil que solicita",
    users: "Usuario(s)",
    usersUsing: " usando este perfil",
    permissions: "Permisos",
    explainRequest: "Explique la solicitud",
    insertExplainRequest:
      "Describa por qué esta solicitud de perfil es relevante para la estructura de su equipo para ayudarnos en la aprobación",
    waitingAproval: "En espera de la aprobación",
    requestCreated: "Su solicitud ha sido enviada",
    describeConfirmedRequest: "Espere el análisis para la aprobación.",
    cancelRequest: "Cancelar la solicitud",
    requestNewProfileButton: "Request Nuevo Profile",
    viewProfile: "Ver perfil",
    userAmount: "usuario| usuarios",
    userAmountText: "relacionados a esse perfil",
    titleCancelRequest: "¿Realmente quieres cancelar esa solicitud",
    textCancelRequest: "Por favor, confirme la cancelación",
    confirmedCancelRequest: "Cancelar la cita",
    requestNewProfileCardText: "Click para solicitar un nuevo perfil",
    requestCreatedAt: "Solicitud creada",
    reject: "Rechazar",
    approve: "Aprobar",
    approvalConfirmation: "Are you sure you want to approve this profile?",
    rejectionConfirmation: "Are you sure you want to reject this profile?",
    denialReason: "Please explain why the request was rejected",
    denialExplanation: "Explain cleary why the customer request was rejected."
  }
}

export default userProfiles
